import React, { forwardRef, useEffect, useState } from 'react'
import axios from 'axios';
import PropTypes from 'prop-types'
import { PlayButtonInner, PlayButtonMain, PlayerTime, PlayButtonCircle, PlayButtonContent, PlayerLabel } from './index.style'
import IconPlay from '@svgs/IconPlay'
import useYoutube from './useYoutube'

const PlayButton = forwardRef(({ text = 'Play', show = true, clickEvent, mouseMove, mouseLeave, videoId, type }, ref) => {
  const [duration, setDuration] = useState(null);
  let vid = videoId;
  let apiUrl = `https://vimeo.com/api/v2/video/${vid}.xml`;
  const { getVideoDuration } = useYoutube();

  useEffect(() => {

    if (vid.includes('vimeo.com/')) {
      // Extract the video ID from the URL
      const urlParts = vid.split('/');
      const videoIdNew = urlParts[urlParts.length - 1];

      // Remove any additional query parameters
      const videoIdParts = videoIdNew.split('?');
      const vids = videoIdParts[0];
      apiUrl = `https://vimeo.com/api/v2/video/${vids}.xml`;
      getVimeo(apiUrl);
    }else if (vid.includes('youtube.com/watch') || vid.includes('youtu.be/')) {
      const urlParams = new URLSearchParams(new URL(vid).search);
      vid = urlParams.get('v') || vid.split('/').pop();

      // Remove any additional query parameters
      const videoIdParts = vid.split('?');
      const vids = videoIdParts[0];

      const fetchDuration = async (vids) => {
        if (vids) {
          const duration = await getVideoDuration(vids);
          setDuration(duration);
        }
      };
  
      fetchDuration(vids);
    }else {
      if(type === "ContentfulYouTubeVideo") {
        const fetchDuration = async (vid) => {
          if (vid) {
            const duration = await getVideoDuration(vid);
            setDuration(duration);
          }
        };
    
        fetchDuration(vid);
      }else {
        apiUrl = `https://vimeo.com/api/v2/video/${vid}.xml`;
        getVimeo(apiUrl);
      }
    }
  }, [videoId]);

  const getVimeo = (apiUrl) => {
    axios
      .get(apiUrl)
      .then(response => {
        const xmlData = response.data;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlData, 'text/xml');
        const videoDuration = xmlDoc.getElementsByTagName('duration')[0].textContent;
        
        // Convert the duration to mm:ss format
        const totalSeconds = parseInt(videoDuration, 10);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const formattedDuration = `${minutes}:${seconds.toString().padStart(2, '0')}`;

        setDuration(formattedDuration);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  return (
    <PlayButtonMain ref={ref} onClick={clickEvent} onMouseMove={mouseMove} onMouseLeave={mouseLeave}>
      <PlayButtonInner>
        <PlayButtonCircle show={show}><IconPlay /></PlayButtonCircle>
        <PlayButtonContent>
          <PlayerLabel><storng>PLAY VIDEO</storng></PlayerLabel>
          <PlayerTime>{duration ? <p>{duration}</p> : <p>...</p>}</PlayerTime>
        </PlayButtonContent>
      </PlayButtonInner>
    </PlayButtonMain>
  )
})

PlayButton.propTypes = {
  text: PropTypes.string,
  show: PropTypes.bool,
}

export default PlayButton
